import axios from "axios";

/**
 * Public, read-only blog API (Edoubleone CMS). No auth; CORS is open.
 * Endpoints: /posts (?category ?tag ?author ?featured=1 ?search ?page ?per_page),
 * /posts/{slug}, /categories, /tags, /authors, /config.
 */
const blogClient = axios.create({
  baseURL: process.env.REACT_APP_BLOG_API_URL || "https://e1app.edoubleone.com/api/v1/e1xacademy",
  timeout: 20000,
});

export const fetchPosts = (params = {}) =>
  blogClient.get("/posts", { params }).then((res) => ({
    posts: res.data?.data || [],
    meta: res.data?.meta || { current_page: 1, last_page: 1, total: 0 },
  }));

export const fetchPost = (slug) => blogClient.get(`/posts/${encodeURIComponent(slug)}`).then((res) => res.data?.data);

export const fetchCategories = () => blogClient.get("/categories").then((res) => res.data?.data || []);

export default blogClient;
